// extracted by mini-css-extract-plugin
export default {"donateIcon":"DonateModal_donateIcon__InKdR"};